import { cn as e } from "../../cn.js";
import t from "react";
import { ChevronDown as n, X as r } from "lucide-react";
import { cva as i } from "class-variance-authority";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Field as s, useFieldContext as c } from "@ark-ui/react/field";
import { Fieldset as l } from "@ark-ui/react/fieldset";
// src/design/forms/shared/form-primitives.tsx
var u = i("text-label font-medium text-foreground", {
	variants: {
		required: {
			true: "",
			false: ""
		},
		disabled: {
			true: "",
			false: ""
		}
	},
	defaultVariants: {
		required: !1,
		disabled: !1
	}
}), d = i("text-destructive ml-0.5"), f = i("text-xs text-muted-foreground"), p = i("text-xs text-destructive font-normal"), m = i("flex flex-col gap-0.5 w-full", {
	variants: { disabled: {
		true: "opacity-90 cursor-not-allowed",
		false: ""
	} },
	defaultVariants: { disabled: !1 }
}), h = i(["transition-transform duration-normal", "text-muted-foreground"], {
	variants: {
		size: {
			sm: "w-3.5 h-3.5",
			md: "w-4 h-4",
			lg: "w-5 h-5"
		},
		disabled: {
			true: "opacity-50",
			false: ""
		},
		open: {
			true: "rotate-180",
			false: "rotate-0"
		}
	},
	defaultVariants: {
		size: "md",
		disabled: !1,
		open: !1
	}
}), g = i([
	"inline-flex items-center justify-center cursor-pointer rounded-md",
	"rounded-sm",
	"text-muted-foreground",
	"transition-colors duration-normal",
	"hover:bg-accent hover:text-foreground",
	"focus-ring",
	"disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
], {
	variants: { size: {
		sm: "w-4 h-4 p-0.5",
		md: "w-6 h-6 p-1",
		lg: "w-6 h-6 p-1"
	} },
	defaultVariants: { size: "md" }
}), _ = t.forwardRef(({ children: t, className: n, required: r = !1, requiredClassName: i = "", disabled: c, ...l }, f) => /* @__PURE__ */ o(s.Label, {
	ref: f,
	className: e(u({
		required: r,
		disabled: c
	}), n),
	...l,
	children: [t, r && /* @__PURE__ */ a(s.RequiredIndicator, { className: e(d(), i) })]
}));
_.displayName = "FormLabel";
var v = t.forwardRef(({ children: t, className: n, required: r, requiredClassName: i, disabled: s, ...c }, f) => /* @__PURE__ */ o(l.Legend, {
	ref: f,
	className: e(u({
		required: r,
		disabled: s
	}), n),
	...c,
	children: [t, r && /* @__PURE__ */ a("span", {
		className: e(d(), i),
		children: "*"
	})]
}));
v.displayName = "FormSetLabel";
var y = t.forwardRef(({ children: t, className: n, ...r }, i) => /* @__PURE__ */ a(s.HelperText, {
	ref: i,
	className: e(f(), n),
	...r,
	children: t
}));
y.displayName = "FormHelperText";
var b = t.forwardRef(({ children: t, className: n, ...r }, i) => /* @__PURE__ */ a(l.HelperText, {
	ref: i,
	className: e(f(), n),
	...r,
	children: t
}));
b.displayName = "FormSetHelperText";
var x = t.forwardRef(({ children: t, className: n, ...r }, i) => c() ? /* @__PURE__ */ a(s.ErrorText, {
	ref: i,
	className: e(p(), n),
	...r,
	children: t
}) : /* @__PURE__ */ a("div", {
	ref: i,
	role: "alert",
	className: e(p(), n),
	...r,
	children: t
}));
x.displayName = "FormErrorText";
var S = t.forwardRef(({ children: t, className: n, ...r }, i) => /* @__PURE__ */ a(l.ErrorText, {
	ref: i,
	className: e(p(), n),
	...r,
	children: t
}));
S.displayName = "FormSetErrorText";
var C = t.forwardRef(({ size: t = "md", disabled: r = !1, open: i = !1, className: o }, s) => /* @__PURE__ */ a("div", {
	ref: s,
	className: e(h({
		size: t,
		disabled: r,
		open: i
	}), o),
	children: /* @__PURE__ */ a(n, { className: "w-full h-full" })
}));
C.displayName = "FormChevronIcon";
var w = t.forwardRef(({ size: t = "md", iconSize: n, className: i, children: o, as: s = "button", "aria-label": c = "Clear", ...l }, u) => {
	let d = o || /* @__PURE__ */ a(r, {
		size: n || (t === "sm" ? 12 : t === "lg" ? 16 : 14),
		strokeWidth: 2
	});
	if (s === "span") {
		let { onClick: n, onKeyDown: r, disabled: o, type: s, ...f } = l;
		return /* @__PURE__ */ a("span", {
			ref: u,
			role: "button",
			"aria-label": c,
			tabIndex: o ? -1 : 0,
			"aria-disabled": o || void 0,
			className: e(g({ size: t }), i),
			onClick: o ? void 0 : (e) => n?.(e),
			onKeyDown: (e) => {
				r?.(e), o || e.key !== "Enter" && e.key !== " " || (e.preventDefault(), e.stopPropagation(), n?.(e));
			},
			...f,
			children: d
		});
	}
	return /* @__PURE__ */ a("button", {
		"aria-label": c,
		ref: u,
		type: "button",
		className: e(g({ size: t }), i),
		...l,
		children: d
	});
});
w.displayName = "FormClearButton";
export { C as FormChevronIcon, w as FormClearButton, x as FormErrorText, y as FormHelperText, _ as FormLabel, S as FormSetErrorText, b as FormSetHelperText, v as FormSetLabel, h as chevronStyles, h as formChevronStyles, g as clearButtonStyles, g as formClearButtonStyles, p as errorTextStyles, p as formErrorTextStyles, f as formHelperTextStyles, f as helperTextStyles, u as formLabelStyles, u as labelStyles, m as formRootStyles, m as rootStyles, d as requiredIndicator };

//# sourceMappingURL=form-primitives.js.map